import { parseJson } from "../utils/json";

export function handleJsonPreProcessing(content: string) {
  //I need to see the format type from the parser
  //I need to call this from the parser... So json calls json parser
  //and markdown calls the markdown prepocess

  // If content is null or undefined, return error
  if (!content) {
    return {
      error: true,
      message: "No content provided",
      rawContent: JSON.stringify(content),
    };
  }

  let jsonContent = content;

  // Remove markdown code block wrappers if present
  if (typeof jsonContent === "string" && jsonContent.includes("```json")) {
    jsonContent = jsonContent
      .replace(/^```json\n?/, "") // Remove opening ```json
      .replace(/\n```[\S\s]*$/, "") // Remove closing ``` and any content after it
      .trim();
  }

  let parsed;
  try {
    parsed =
      typeof jsonContent === "string" ? parseJson(jsonContent) : jsonContent;
  } catch (error) {
    console.error("Failed to parse jsonContent:", {
      input: jsonContent,
      type: typeof jsonContent,
      length: typeof jsonContent === "string" ? jsonContent.length : undefined,
      error: error instanceof Error ? error.message : error,
      stack: error instanceof Error ? error.stack : undefined,
    });
    parsed = {};
  }
  return parsed;
}
